// @flow
export default function convertOr<T> (decode: (value: mixed) => T, defaultTo: ?T): (value: mixed) => ?T {
  const defaultReturn: T | null = defaultTo == null ? null : defaultTo

  return function decodeOr (value: mixed): ?T {
    if (value == null) {
      return defaultReturn
    }

    const parsed: T = decode(value)

    if ((parsed == null) || (typeof parsed === 'number' && isNaN(parsed))) {
      return defaultReturn
    }

    return parsed
  }
}
